@if (parseError) {
  <p class="dash-error">This dashboard couldn't be displayed. Use Open in new tab or Download above.</p>
} @else {
  <div class="dash-root">
    <div class="dash-toolbar">
      @if (generatedAt) { <span class="dash-generated">Generated {{ generatedAt }}</span> }
      <button type="button" class="dash-refresh" (click)="onRefresh()" title="Re-run with the latest data">
        <i class="pi pi-refresh" aria-hidden="true"></i> Refresh
      </button>
    </div>

    @if (!cards.length) {
      <p class="dash-error">This dashboard has no sections yet.</p>
    }

    <div class="dashboard-grid">
      @for (card of cards; track trackCard($index, card)) {
        <section class="dash-card">
          <h3>{{ card.title }}</h3>

          @if (card.empty) {
            <p class="dash-empty">No data available.</p>
          } @else {
            @switch (card.kind) {

              @case ('kpi') {
                <div class="dash-kpi">
                  <div class="dash-kpi-num">{{ card.kpiValue }}</div>
                  @if (card.kpiLabel) { <div class="dash-kpi-lbl">{{ card.kpiLabel }}</div> }
                  @if (card.kpiSub) { <div class="dash-kpi-sub">{{ card.kpiSub }}</div> }
                </div>
              }

              @case ('bar') {
                <svg class="dash-svg" [attr.viewBox]="'0 0 320 ' + card.barHeight" role="img"
                     preserveAspectRatio="xMinYMin meet" [attr.aria-label]="card.title">
                  @for (b of card.bars; track b.label) {
                    <g class="dash-bar-row" (click)="onSegment(card, b.label)">
                      <title>{{ b.label }}: {{ b.display }}</title>
                      <text [attr.x]="(card.labelW || 0) - 8" [attr.y]="b.y + 16"
                            text-anchor="end" class="dash-lbl">{{ b.label.length > 30 ? (b.label | slice:0:30) : b.label }}</text>
                      <rect [attr.x]="card.labelW" [attr.y]="b.y" [attr.width]="b.w" height="22"
                            rx="3" class="dash-bar"></rect>
                      <text [attr.x]="(card.labelW || 0) + b.w + 6" [attr.y]="b.y + 16"
                            class="dash-num">{{ b.display }}</text>
                    </g>
                  }
                </svg>
              }

              @case ('line') {
                <svg class="dash-svg" viewBox="0 0 320 160" role="img"
                     preserveAspectRatio="xMinYMin meet" [attr.aria-label]="card.title">
                  <line x1="36" [attr.y1]="card.lineAxisY" x2="308" [attr.y2]="card.lineAxisY" class="dash-axis"></line>
                  <polyline class="dash-line" [attr.points]="card.linePoints"></polyline>
                  @for (d of card.lineDots; track $index) {
                    <circle [attr.cx]="d.x" [attr.cy]="d.y" r="3" class="dash-dot"></circle>
                  }
                  @for (l of card.lineLabels; track $index) {
                    <text [attr.x]="l.x" y="152" text-anchor="middle" class="dash-lbl">{{ l.label }}</text>
                  }
                </svg>
              }

              @case ('pie') {
                <div class="dash-pie-wrap">
                  <svg class="dash-pie" viewBox="0 0 160 160" role="img" [attr.aria-label]="card.title">
                    @for (s of card.slices; track $index) {
                      <path [attr.d]="s.d" [attr.fill]="s.color" class="dash-slice"
                            (click)="onSegment(card, s.label)">
                        <title>{{ s.label }}: {{ s.value }} ({{ s.pct }}%)</title>
                      </path>
                    }
                  </svg>
                  <div class="dash-legend">
                    @for (s of card.slices; track $index) {
                      <div class="dash-leg-item" (click)="onSegment(card, s.label)">
                        <span class="dash-swatch" [style.background]="s.color"></span>
                        {{ s.label }} <b>{{ s.value }}</b> ({{ s.pct }}%)
                      </div>
                    }
                  </div>
                </div>
              }

              @default {
                <table class="dash-table">
                  <thead>
                    <tr>@for (c of card.columns; track $index) { <th>{{ c }}</th> }</tr>
                  </thead>
                  <tbody>
                    @for (row of card.rows; track $index) {
                      <tr>@for (cell of row; track $index) { <td>{{ cell }}</td> }</tr>
                    }
                  </tbody>
                </table>
              }
            }
          }
        </section>
      }
    </div>
  </div>
}
